import React from 'react';
import { IMargin } from '../../../interface/interface';
import { getInlineStyles } from '../../../utils/styles';
import { TextCommon } from '../../UI/Text/TextCommon';
import styles from '../Calculator.module.css';

interface TPricingTabProps extends IMargin {
    text?: string;
    fee?: string;
}

const PricingTab = (props: TPricingTabProps) => {
    const margin = {
        top: props.marginTop,
        bottom: props.marginBottom,
        left: props.marginLeft,
        right: props.marginRight,
    };
    return (
        <div className={styles.pricingTabBlock} style={getInlineStyles({ margin })}>
            <TextCommon isWidget={false} as={'span'} content={props.text} options={{ variant: 'subheader', textColor: 'black' }} />
            <TextCommon isWidget={false} as={'span'} content={props.fee} options={{ variant: 'subheader', textColor: 'purple_100' }} />
        </div>
    );
};
export default PricingTab;
